import { ADD_ERROR_MESSAGE, ADD_SUCCESS_MESSAGE, CLEAR_MESSAGES, ADD_CMD_MESSAGE } from './types'

export const addSuccessMessage = (message: string) => ({ type: ADD_SUCCESS_MESSAGE, messages: { error: "", success: message, cmd: '' }})

export const addErrorMessage = (message: string) => ({ type: ADD_ERROR_MESSAGE, messages: { error: message, success: "", cmd: '' }})

export const addCmdMessage = (message: string) => ({ type: ADD_CMD_MESSAGE, messages: { error: '', success: "", cmd: message }})

export const clearMessages = () => ({ type: CLEAR_MESSAGES, messages: { error: "", success: "" }})